import dateFormat from "dateformat";
import { NOTIFICATION_TYPE } from "./const";

export const validateFields = (
  schema: any,
  formNames: string[],
  values: any[]
) => {
  return new Promise((resolve, reject) => {
    let data: any = {};
    formNames.map((formName, index) => {
      data[formName] = values[index];
    });
    schema
      .validate(data, { abortEarly: false })
      .then(() => {
        resolve(true);
      })
      .catch((error: any) => {
        reject(new Error(error.inner[0].message));
      });
  });
};

export const getFormattedDateTime = (dateString: string | number | Date) => {
  return dateFormat(dateString, "yyyy-mm-dd hh:MM:ss");
};

export const getFormattedDate = (dateString: string | number | Date) => {
  return dateFormat(dateString, "yyyy-mm-dd");
};

export const generateRandomRequestID = () => {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < 6) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return "upcx_webwallet_" + Date.now() + "_" + result;
};
